import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [
  {
    id: "categories",
    label: "Categories",
    path: "/app/admin/manage-products/categories",
  },
  {
    id: "classes",
    label: "Classes and Managers",
    path: "/app/admin/manage-products/classes",
  },
  {
    id: "competitor-products",
    label: "Competitor Products",
    path: "/app/admin/manage-products/competitor-products",
  },
  {
    id: "equivalents",
    label: "Equivalent Products",
    path: "/app/admin/manage-products/equivalents",
  },
  {
    id: "instructions",
    label: "Instructions",
    path: "/app/admin/manage-products/instructions",
  },
  {
    id: "test-templates",
    label: "Quality Test Templates",
    path: "/app/admin/manage-products/test-templates",
  },
]

export const Route = createFileRoute("/app/admin/manage-products/_layout")({
  component: ManageProductLayout,
})

function ManageProductLayout() {
  return <TabsLayout title='Manage Products' tabs={tabs} />
}
